import { formatApiError } from '@consigli/hooks';
import { StatusVariant } from '@consigli/types';
import { type SerializedError } from '@reduxjs/toolkit';
import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { Alert } from '@/components';

interface LoadErrorProps {
  title: string;
  error: FetchBaseQueryError | SerializedError;
}

export const LoadError = ({ title, error }: LoadErrorProps) => (
  <Alert
    variant={StatusVariant.ERROR}
    title={title}
    description={formatApiError(error) ?? 'Unknown error'}
  />
);
